module.exports = __webpack_public_path__ + "src/assets/img/illustrations/week-in-review.5ea52061dc7f08890ed080dcf9ca4f7e.gif";